import { Link } from 'react-router-dom'
import { SlashCircle } from '@/assets/icons'
import { kMattersRoute } from '@/matter/constants'

/**
 * Banner shown at the top of the drive when the active matter is the
 * legacy "Unassigned" matter that informs the user that uploads are disabled.
 */
export function UnassignedMatterBanner() {
  return (
    <div className="flex flex-col items-center justify-center gap-1 bg-brand-neutral-100 px-4 py-5 text-center rounded-lg border h-[133px]">
      <SlashCircle className="h-[22px] w-[22px] text-brand-neutral-400" />
      <h1 className="font-medium">Uploads aren't available in this space</h1>
      <p className="text-sm text-brand-neutral-800">
        "Unassigned" is view only. Upload or move files into a matter to continue.{' '}
        <Link to={kMattersRoute} className="text-brand-500 underline underline-offset-2">
          All Matters
        </Link>
      </p>
    </div>
  )
}
